export type TimeScale = 'daily' | 'hourly'

export type WidgetConfig = {
  enabled: boolean
  position: number
  tool_tip: {
    primary_text: string
    secondary_text: string
  }
  l2_config?: {
    primary: string
  }
  l2_present: boolean
  widget_title: string
  impact_config: boolean
  drop_down_Config: any[]
  benchmark_present: boolean
  comparison_config: {
    negative_colour: string
    positive_colour: string
  }
  previous_period_config: boolean
  widget_id: string
  endpoint: string
  group: string
  threshold_alerts_supported: boolean
}

export enum WidgetSections {
  summary = 'summary',
  conversion = 'conversion',
  payments = 'payments',
  orders = 'orders',
  discounts = 'discounts',
  rto = 'rto',
  // additional sections
  upsells = 'upsells',
  rewards = 'rewards'
}

export type Widgets = {
  widgetConfig: {
    [key in WidgetSections]: WidgetConfig[]
  }
}

export enum Endpoint {
  repeat_customers = 'repeat-customers',
  conversion_rate = 'conversion-rate',
  conversion_funnel = 'conversion-funnel',
  conversions = 'conversions',
  prepaid_share = 'prepaid-share',
  order_details = 'order-details',
  prefilled_address_timeScale = 'prefilled-address-timeScale',
  prefilled_address = 'prefilled-address'
}

// todo(shradhan): this will changes as widget ids are same for different endpoints
export enum WidgetId {
  // summary
  summary_conversion_rate = 'summary_conversion_rate',
  summary_net_sales = 'summary_net_sales',
  summary_aov = 'summary_aov',
  summary_orders = 'summary_orders',
  summary_prepaid_share = 'summary_prepaid_share',

  // conversion
  conversion_rate = 'conversion_rate',
  conversion_funnel = 'conversion_funnel',
  conversion_address_prefilled_rate = 'conversion_address_prefilled_rate',
  conversion_rate_comparison = 'conversion_rate_comparison',
  conversion_rate_timescale = 'conversion_rate_timescale',
  conversion_auto_logged_in_sessions = 'identification_rate_over_time',
  exit_checkout_survey = 'exit_checkout_survey',

  // payments
  payment_split = 'payment_split',
  payment_prepaid_share = 'payment_prepaid_share',
  payment_methods_conversion_rates = 'payment_methods_conversion_rates',
  payment_gateways_success_rate = 'payment_gateways_success_rate',

  // orders
  orders = 'orders',
  orders_breakdown = 'orders_breakdown',
  orders_sales = 'orders_sales',
  orders_average_order_value = 'orders_average_order_value',
  orders_sales_breakdown = 'orders_sales_breakdown',
  orders_abandoned_checkout_recovery = 'orders_abandoned_checkout_recovery',
  orders_sales_breakdown_by_utm = 'orders_sales_breakdown_by_utm',

  // discounts
  discounts_conversion_rate = 'discounts_conversion_rate',
  discounts_average_order_value = 'discounts_average_order_value',
  discounts_order_placed_comparison = 'discounts_order_placed_comparison',
  discounts_your_discounts = 'discounts_your_discounts',

  // cod
  cod_orders_converted_to_prepaid = 'cod_orders_converted_to_prepaid',

  // rto
  rto_orders_converted_to_prepaid = 'rto_orders_converted_to_prepaid',

  // upsells
  upsells_orders_converted_to_prepaid = 'upsells_orders_converted_to_prepaid',

  // rewards
  rewards_orders_converted_to_prepaid = 'rewards_orders_converted_to_prepaid'
}

export type AnalyticsState = {
  isLoading: boolean
  widgetConfig: Widgets['widgetConfig']
}
